import { render } from "./Warnings.vue?vue&type=template&id=abe67d2a&scoped=true"
import script from "./Warnings.vue?vue&type=script&lang=js"
export * from "./Warnings.vue?vue&type=script&lang=js"

import "./Warnings.vue?vue&type=style&index=0&id=abe67d2a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abe67d2a"]])

export default __exports__